import '../vendors/aws-sdk-2.422.0.min.js';

const AWS = window.AWS;
export default AWS;
